var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 4.83321L11.666 7.49988M2.66602 13.8332H5.33268L12.3327 6.83321C12.6863 6.47959 12.885 5.99997 12.885 5.49988C12.885 4.99978 12.6863 4.52016 12.3327 4.16654C11.9791 3.81292 11.4994 3.61426 10.9993 3.61426C10.4993 3.61426 10.0196 3.81292 9.66602 4.16654L2.66602 11.1665V13.8332Z",
    stroke: "#0B93E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8fc7f091d9e257a061f2b2d73c7874b6.svg";
export { ForwardRef as ReactComponent };